import { render, staticRenderFns } from "./EditLandfillPlan.vue?vue&type=template&id=78965fb8"
import script from "./EditLandfillPlan.vue?vue&type=script&lang=js"
export * from "./EditLandfillPlan.vue?vue&type=script&lang=js"
import style0 from "./EditLandfillPlan.vue?vue&type=style&index=0&id=78965fb8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports